import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'maglive-gift-question',
  templateUrl: './gift-question.component.html',
  styleUrls: ['./gift-question.component.scss'],
})
export class GiftQuestionComponent {
  @Input() isOpenQuestionModal: boolean
  @Input() isScreenRotated: boolean
  @Output() giftQuestionModalEvent = new EventEmitter<void>()

  closeQuestionModal() {
    this.giftQuestionModalEvent.emit()
  }
}
